<template>
	<div>
	<el-dialog width="500px" :visible.sync="dialogTableVisible" :close-on-click-modal= "false">
		<el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="left" label-width="0px" class="login-form">
		  <h3 class="title">余米平台{{(type=='enterprise')?'企业':'供应商'}}注册</h3>
		  <el-form-item prop="username">
		    <el-input v-model="loginForm.username" type="text" auto-complete="off" :placeholder="usernamePlaceholder">
		      <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon"/>
		    </el-input>
		  </el-form-item>
		  <el-form-item prop="password">
		    <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="密码" @keyup.enter.native="handleSignUp">
		      <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon"/>
		    </el-input>
		  </el-form-item>
		  <el-form-item prop="checkPass">
		    <el-input v-model="loginForm.checkPass" type="password" auto-complete="off" placeholder="请再次输入密码" @keyup.enter.native="handleSignUp">
		      <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon"/>
		    </el-input>
		  </el-form-item>
		  <el-form-item prop="code">
		    <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: 67%" @keyup.enter.native="handleSignUp">
		      <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon"/>
		    </el-input>
		    <div class="login-code">
		      <img :src="codeUrl" @click="getCode">
		    </div>
		  </el-form-item>
		   <el-form-item v-if="type!='enterprise'" style="text-align: left;">
		 <!-- <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住我</el-checkbox> -->
		 <el-checkbox v-model="agreed" style="margin:0px 10px 25px 0px;"></el-checkbox><span>同意<span style="color:#2196F3;"  @click="dialogVisible=true">《余米注册协议》</span></span>
		 </el-form-item>
		  <el-form-item style="width:100%;">
		    <el-button class="sign_up_button" :loading="loading"  style="width:100%;" @click.native.prevent="handleSignUp">
		      <span v-if="!loading">注 册</span>
		      <span v-else>正在处理...</span>
		    </el-button>
		  </el-form-item>
		</el-form>
		</el-dialog>
		<el-dialog
		  title="自由职业者服务协议"
		  :visible.sync="dialogVisible"
		  width="50%"
		  >
		  <contact/>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import { encrypt } from '../../utils/rsaEncrypt.js'
	
	import {
		getCodeImg,
		signUpEnterprise,
		signUpSupplier,
		login
	} from '../../api/login.js'

	import Cookies from 'js-cookie'
	import {setToken} from '../../utils/auth.js'
	import contact from '../contact/contact.vue'
	export default{
		components:{
			contact
		},
		computed:{
			
			usernamePlaceholder:function(){
				
				return (this.type=='enterprise')?'请输入社会信用证号':'请输入手机号码'
				
				
			}
		
			
			
		},
		data(){
			var checkPassFn = (rule, value, callback) => {
			         if (value === '') {
			                  callback(new Error('请再次输入密码'));
			                } else if (value !== this.loginForm.password) {
			                  callback(new Error('两次输入密码不一致!'));
			                } else {
			                  callback();
			          }
			      };
			
			return {
				dialogVisible:false,
				agreed:false,
				type:"",
				dialogTableVisible:false,
				codeUrl: '',
				cookiePass: '',
				loginForm: {
				  username: '',
				  password: '',
				  checkPass: '',
				  rememberMe: false,
				  phone: '',
				  email: 'test@test.com',
				  enabled: 'true',
				  code: '',
				  uuid: ''
				},
				loginRules: {
				  username: [{ required: true, trigger: 'blur', message: "不能为空" }],
				  password: [{ required: true, trigger: 'blur', message: '密码不能为空' }],
				  code: [{ required: true, trigger: 'change', message: '验证码不能为空' }],
				  checkPass: [{  validator: checkPassFn, message: '请再次输入密码', trigger: 'blur' }]
				},
				loading: false,
				redirect: undefined
			}
			
		},
		methods: {
		  getCode() {
		    getCodeImg().then(res => {
				console.log('[res]',res);
		      this.codeUrl = 'data:image/gif;base64,' + res.img
		      this.loginForm.uuid = res.uuid
		    })
		  },
		  getCookie() {
		    const username = Cookies.get('username')
		    let password = Cookies.get('password')
		    const rememberMe = Cookies.get('rememberMe')
		    // 保存cookie里面的加密后的密码
		    this.cookiePass = password === undefined ? '' : password
		    password = password === undefined ? this.loginForm.password : password
		    this.loginForm = {
		      username: username === undefined ? this.loginForm.username : username,
		      password: password,
		      rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
		      code: ''
		    }
		  },
		  handleSignUp() {
			  if(this.type!='enterprise'&&!this.agreed){
				  this.$alert('必须要同意余米协议', '提示', {
				     confirmButtonText: '确定'
				  })
			  }
			  
			  
		    console.log("handleSignUp")
		    this.$refs.loginForm.validate(valid => {
		
		      const user = {
		        username: this.loginForm.username,
		        password: this.loginForm.password,
		        rememberMe: this.loginForm.rememberMe,
		        code: this.loginForm.code,
		        uuid: this.loginForm.uuid
		      }
		      if (user.password !== this.cookiePass) {
		        user.password = encrypt(user.password)
		      }
		      if (valid) {
		         this.loading = true

					 
		        this.SignUp().then(res => {
		          this.loading = false
		         //setToken(res.token)
		         
		         this.$store.dispatch('Login', user).then(() => {
		           this.loading = false
		         this.dialogTableVisible = false
				 //发起一次登录
				 login(this.loginForm.username, this.loginForm.password, this.loginForm.code, this.loginForm.uuid).then(res => {
				 	setToken(res.token)
				 	this.$store.dispatch("Login",res.user)
				 	 this.$notify({
				 			  type: 'success',
				 	          title: '提示',
				 	          message: '注册成功',
				 	          duration: 2000
				 	  });
				 })
		         }).catch(() => {
		           this.loading = false
		           this.getCode()
		         })
				 
		        }).catch(() => {
		          this.loading = false
		          this.getCode()
		        })
		      } else {
		        console.log('error submit!!')
		        return false
		      }
		    })
		  },
		  SignUp(){
			  
			  if(this.type=='enterprise'){
				  this.loginForm.phone = '15916303254'
				  return signUpEnterprise(this.loginForm)
			  }
			  else{
				   this.loginForm.phone = this.loginForm.username
				  return signUpSupplier(this.loginForm)
			  }
			 
		  }
		},
		watch:{
			
			type:function(val){
				
				this.loginRules.username[0].message = (val=='enterprise')?'社会信用证号不能为空':'手机号码不能为空'
				
				
			}
			
		}
		
		
	}
	
	
</script>

<style rel="stylesheet/scss" lang="scss">

	.title {
	  margin: 0px auto 30px auto;
	  text-align: center;
	  color: #707070;
	}
	
	.login-form {
	  border-radius: 6px;
	  background: #ffffff;
	  width: 400px;
	  padding: 25px 25px 5px 25px;
	  .el-input {
	    height: 38px;
	    input {
	      height: 38px;
	    }
	  }
	  .input-icon{
	    height: 39px;width: 14px;margin-left: 2px;
	  }
	}
	.login-tip {
	  font-size: 13px;
	  text-align: center;
	  color: #bfbfbf;
	}
	.login-code {
	  width: 33%;
	  display: inline-block;
	  height: 38px;
	  float: right;
	  img{
	    cursor: pointer;
	    vertical-align:middle
	  }
	}
	.sign_up_button{
		width: 14.11vw;
		height: 2.24vw;
		background-image: linear-gradient(259deg,
			#527ef8 0%,
			#495bea 43%,
			#4037dc 100%),
			linear-gradient(#337df7,
			#337df7);
		background-blend-mode: normal,
			normal;
		border-radius: 0.21vw;
		line-height: 2.24vw;
		text-align: center;
		color: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.sign_up_button span{
		line-height: 0;
	}
	
</style>
